/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PriceBound } from './priceBound';


export interface ServiceSubscription { 
    id: string;
    serviceName?: string;
    type?: string;
    description?: string;
    creatorId?: string;
    serviceCode?: string;
    lastDateSubscribed: Date;
    priceBound?: Array<PriceBound>;
    errorMessage?: string;
    subscriptionStatus: boolean;
    serviceId?: string;
}
